import React from "react";
import tw from "tailwind-styled-components";
import { MdFolder, MdUploadFile } from "react-icons/md";

const DocumentActionMenu = ({
  isOpen,
  onUploadClick,
  onCreateFolderClick,
}) => {
  if (!isOpen) return null;

  return (
    <Container>
      <ActionButton onClick={onUploadClick}>
        <IconWrapper className="bg-blue-50 group-hover:bg-blue-100">
          <MdUploadFile size={18} className="text-blue-600" />
        </IconWrapper>

        <div className="text-left">
          <p className="text-sm font-semibold text-gray-800">
            Upload Document
          </p>
          <p className="text-xs text-gray-500">
            Upload PDF or Image
          </p>
        </div>
      </ActionButton>

      <Divider />

      <ActionButton onClick={onCreateFolderClick}>
        <IconWrapper className="bg-yellow-50 group-hover:bg-yellow-100">
          <MdFolder size={18} className="text-yellow-600" />
        </IconWrapper>

        <div className="text-left">
          <p className="text-sm font-semibold text-gray-800">
            Create Folder
          </p>
          <p className="text-xs text-gray-500">
            Organize your documents
          </p>
        </div>
      </ActionButton>
    </Container>
  );
};

export default DocumentActionMenu;

const Container = tw.div`
absolute
right-0
top-14
w-72
bg-white
border
border-gray-100
rounded-2xl
shadow-xl
overflow-hidden
z-50
`;

const ActionButton = tw.button`
group
flex
w-full
items-start
gap-3
px-5
py-4
hover:bg-gray-50
transition
`;

const IconWrapper = tw.div`
p-2
rounded-lg
transition
`;

const Divider = tw.div`
mx-4
h-px
bg-gray-100
`;